import { Directive, forwardRef, Input, Type } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

export enum Titles {
  CEO = 'CEO',
  VP = 'VP',
  COO = 'COO',
  DIRECTOR = 'DIRECTOR',
  PRESIDENT = 'PRESIDENT',
  SVP = 'SVP'
}

/**
 * tdWbTitleNeedsNameValidator
 * Raises error when there is a title (CEO, VP) but there is no name informed
 */
@Directive({
  selector: '[tdWbTitleNeedsNameValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<TitleNeedsNameValidatorDirective> => TitleNeedsNameValidatorDirective),
    multi: true
  }],
  standalone: false
})
export class TitleNeedsNameValidatorDirective implements Validator {
  @Input() tdWbTitleNeedsNameValidator: { [key in Titles]: boolean };

  validate(thisControl: AbstractControl): ValidationErrors | null {
    const hasTitle = this.tdWbTitleNeedsNameValidator.CEO || this.tdWbTitleNeedsNameValidator.VP ||
      this.tdWbTitleNeedsNameValidator.COO || this.tdWbTitleNeedsNameValidator.DIRECTOR ||
      this.tdWbTitleNeedsNameValidator.PRESIDENT || this.tdWbTitleNeedsNameValidator.SVP;
    const hasName = thisControl.value !== undefined && thisControl.value !== null && thisControl.value !== '';

    const needsName = !hasName && hasTitle;
    const needsTitle = hasName && !hasTitle;

    return (needsName || needsTitle) ? { requiredSubscriberAgentNameAndTitle: true } : null;
  }
}
